import { action } from 'satcheljs';
import { getDefaultLogonEmailAddress } from 'owa-session-store';

/**
 * Action to remove a shared folder user.
 */
export const removeSharedFolderUser = action(
    'REMOVE_SHARED_FOLDER_USER',
    (sharedUserMailboxSmtpAddress: string, userIdentity?: string) => {
        if (!userIdentity) {
            userIdentity = getDefaultLogonEmailAddress();
        }

        return {
            sharedUserMailboxSmtpAddress,
            userIdentity,
        };
    }
);
